<template>
    <v-main>
        <v-row class="ma-0">
            <v-col sm="6" class="d-flex align-end justify-end pb-5 pr-5">
                <strong class="white--text">&copy; {{ new Date().getFullYear() }} TCO TEAM.</strong>
            </v-col>
            <v-col sm="6" class="d-flex justify-center align-center">
                <section class="d-flex flex-column align-center">
                    <router-link :to="{name : 'Home'}">
                        <img :src="require('@/../public/images/TcoTeam.png')">
                    </router-link>

                    <h1>{{$t("auth.welcome")}} {{APP_NAME}}</h1>

                    <p class="mb-11">{{$t("auth.description")}}</p>

                    <section class="sectionForm">
                        <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                            <v-form @submit.prevent="handleSubmit(submit)">
                                <ValidationProvider vid="email" :name="$t('auth.email')" rules="required|email" v-slot="{ errors }">
                                    <v-text-field :label="$t('auth.email')"
                                                  type="email"
                                                  v-model="login.email"
                                    >
                                        <template v-slot:prepend-inner>
                                            <svg v-svg="'icon-email'" size="15" class="mr-1"></svg>
                                        </template>
                                    </v-text-field>
                                    <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                                </ValidationProvider>

                                <ValidationProvider :name="$t('auth.password')" rules="required|min:6" v-slot="{ errors }">
                                    <v-text-field :label="$t('auth.password')" type="password"
                                                  v-model="login.password"
                                    >
                                        <template v-slot:prepend-inner>
                                            <svg v-svg="'icon-password'" size="15" class="mr-1"></svg>
                                        </template>
                                    </v-text-field>
                                    <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                                </ValidationProvider>

                                <v-card-actions class="justify-center mt-7">
                                    <v-btn class="white--text" color="green" type="submit" :loading="loadingRequest" width="90" height="30">{{$t("auth.login")}}</v-btn>
                                </v-card-actions>
                            </v-form>
                        </ValidationObserver>
                    </section>

                    <router-link :to="{name : 'Restore'}" class="mt-7 mb-4 green--text">
                        {{$t("auth.forgot")}}
                    </router-link>

                    <p>{{$t("auth.notRegistered")}}
                        <router-link :to="{name : 'Register'}" class="green--text">
                            {{$t("auth.createAccount")}}
                        </router-link>
                    </p>
                </section>

                <v-footer fixed class="d-none transparent mb-3">
                        <strong class="mx-auto">&copy; {{ new Date().getFullYear() }} TCO TEAM.</strong>
                </v-footer>
            </v-col>
        </v-row>
    </v-main>
</template>

<script>
    export default {
        data(){
            return {
                login: {},
                loadingRequest : false,
            }
        },

        methods: {
            submit(){
                this.loadingRequest = true;
                this.$api('auth').login(this.login)
                    .then((res) => {
                        this.$store.dispatch('LOGIN_HOME', res.data);
                        this.$router.push({name : 'Blog'});
                    }).catch((err) => {
                    let response = err.response;
                    if (response.status === 422) this.$refs.form.setErrors(response.data);
                    if (err.response.status === 302 ) this.$store.dispatch('alert', {type: 4, message: err.response.data.message});
                }).finally(() => {
                    this.loadingRequest = false;
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../scss/pages/auth";
</style>